import type { ReactNode } from "react";
import { StatusPill, type Tone } from "@/modules/shared/status";
import { cn } from "@/lib/utils";

/** Shared list + detail status chip (invoices and subscriptions); same look as every StatusPill. */
export const BillingStatusPill = ({
  tone,
  children,
  className,
}: {
  tone: Tone;
  children: ReactNode;
  className?: string;
}) => (
  <StatusPill tone={tone} className={cn("w-fit", className)}>
    {children}
  </StatusPill>
);
